export default __webpack_public_path__ + "static/media/search-white.8cf0ce01.svg";